import styled from 'styled-components';

const Options = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  margin: 2px 0 12px 0;
  padding: 12px 16px;
  width: 100%;
  box-sizing: border-box;
  max-width: 100%;
  list-style: none;

  @media (max-width: 767px) {
    gap: 10px;
    padding: 8px 8px;
  }

  @media (max-width: 479px) {
    gap: 8px;
    padding: 6px 6px;
  }
`;

export default Options;
